"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorStoreService = exports.makeErrorStoreService = void 0;
const lodash_1 = require("lodash");
function makeErrorStoreService() {
    let errors = {};
    let subscribers = [];
    return {
        setErrors,
        clearErrorsForValidator,
        clearErrors,
        subscribe,
        unsubscribe
    };
    function setErrors(nextErrors) {
        errors = nextErrors;
        informSubscribers();
    }
    function clearErrorsForValidator(validator) {
        (0, lodash_1.set)(errors, validator, []);
        informSubscribers();
    }
    function clearErrors() {
        errors = {};
        informSubscribers();
    }
    function subscribe(subscriber) {
        subscribers.push(subscriber);
        informSubscriber(subscriber);
    }
    function unsubscribe(subscriber) {
        subscribers = subscribers.filter((s) => s !== subscriber);
    }
    function informSubscribers() {
        subscribers.forEach(informSubscriber);
    }
    function informSubscriber(subscriber) {
        if (determineIfSubscriberIsSubscriberSpecific(subscriber)) {
            const errorsForValidator = (0, lodash_1.get)(errors, subscriber.validator, []);
            const errorsAsStringArray = errorsForValidator;
            subscriber.onChange(errorsAsStringArray);
        }
        else {
            subscriber.onChange(errors);
        }
    }
    function determineIfSubscriberIsSubscriberSpecific(subscriber) {
        return subscriber.validator !== undefined;
    }
}
exports.makeErrorStoreService = makeErrorStoreService;
exports.errorStoreService = makeErrorStoreService();
